import React from "react";
import {
  Home,
  DashboardCustomizeOutlined,
  AccessTime,
  Groups2Outlined,
  Business,
  AssignmentOutlined,
  AssessmentOutlined,
  DockOutlined,
  RequestQuoteOutlined,
  Person
} from "@mui/icons-material";

export const typeOfApplication ="ADMIN";

export const statusOptions = [
  { label: "CPT", value: "CPT" },
  { label: "OPT", value: "OPT" },
  { label: "H1", value: "H1" },
  { label: "H4", value: "H4" },
  { label: "EAD", value: "EAD" },
  { label: "Green Card", value: "Green Card" },
  { label: "Citizen", value: "Citizen" },
];

export const AdminNavigation = [
  {
    name: "Dashboard",
    icon: DashboardCustomizeOutlined,
    href: "/",
    children: false,
    access: ["ADMIN", "MKTG_EXEC"]
  },
  {
    name: "Employee",
    icon: Groups2Outlined,
    children: false,
    href: "/manageemployee",
    access: ["ADMIN"]
  },
  {
    name: "Timesheet",
    icon: AccessTime,
    children: true,
    href: "/timesheets",
    access: ["ADMIN"],
    items: [
      { name: "To Be Approved", href: "/pendingTimesheets", access: ["ADMIN"] },
    ],
  }, 
  {
    name: "Invoices",
    icon: RequestQuoteOutlined,
    children: true,
    href: "/invoices",
    access: ["ADMIN"],
    items: [
      { name: "Payment Pending", href: "/pendingInovoices", access: ["ADMIN"] },
    ],
  },
  { name: "Client", icon: Business, href: "/addclient", children: false, access: ["ADMIN"] },
  {
    name: "Project",
    icon: AssignmentOutlined,
    href: "/addproject",
    children: false,
    access: ["ADMIN"]
  },
  {
    name: "Submissions Table",
    icon: AssessmentOutlined,
    href: "/reports/submissions",
    children: false,
    access: ["ADMIN", "MKTG_EXEC"]
  },
  {
    name: "Profile",
    icon: Person,
    href: "/profile-update",
    access: ["ADMIN", "MKTG_EXEC"],
    children: false,
  },
];

export const  primaryColor = "#201F1E";
